
import Polygon from "./polygon";

class extrudedPolygon extends Polygon {
  constructor(obj){
    super(obj)

    const { height, diffHeight } = obj
    this._styleOptions = {
      ...this._styleOptions,
      height: height !== null ? height : 0.0,
      diffHeight: diffHeight !== null ? diffHeight : 1.0
    }
    this._symbol = {
      ...this._symbol,
      styleOptions: this._styleOptions
    }
    this._initObj = {
      ...this._initObj,
      symbol: this._symbol
    }
  }
}

export default extrudedPolygon